import { render, staticRenderFns } from "./WalletConnectWithSave.vue?vue&type=template&id=6089f491&scoped=true&"
import script from "./WalletConnectWithSave.vue?vue&type=script&lang=js&"
export * from "./WalletConnectWithSave.vue?vue&type=script&lang=js&"
import style0 from "./WalletConnectWithSave.vue?vue&type=style&index=0&id=6089f491&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6089f491",
  null
  
)

export default component.exports